import {
  scrollTop
} from '../utilities/scroll';

export default class {
  constructor({
    sectionSelector,
    triggerSelector,
    modalSelector,
    modalContSelector,
    modalCoverup,
    modalNavSelector,
    modalCloseSelector,
    modalArrowSelector,
    modalContent,
  }) {
    /**
     * Variables
     */
    const docBody = document.querySelector('body');
    const heatMapSection = document.querySelector(sectionSelector);
    const heatMapTriggers = heatMapSection.querySelectorAll(triggerSelector);
    const heatMapModal = heatMapSection.querySelector(modalSelector);
    const modalContainer = heatMapModal.querySelector(modalContSelector);
    const modalCoverUp = heatMapModal.querySelector(modalCoverup);
    const modalNavContainer = heatMapModal.querySelector(modalNavSelector);
    const modalClose = heatMapModal.querySelector(modalCloseSelector);
    const modalArrows = heatMapModal.querySelectorAll(modalArrowSelector);
    const modalContents = modalContent;
    // Grab elements from the heatMapModal for changing content
    // TODO: possibly make these selectors part of the settings
    const modalLink = heatMapModal.querySelector('.video__img-container');
    const modalTitle = heatMapModal.querySelector('.configurations__heatmap__content-modal__body-container__title');
    const modalCopy = heatMapModal.querySelector('.configurations__heatmap__content-modal__body-container__copy');
    const modalImg = heatMapModal.querySelector('.configurations__heatmap__content-modal img');

    const CONTENT_LENGTH = modalContents.length;

    /**
     * Utility function for getting the height of the header(navbar)
     */
    const getHeaderHeight = () => document.querySelector('#header').offsetHeight;

    /**
     * Utility function for resetting active state on everything regarding heatmap
     */
    const resetTriggers = () => {
      // Remove active class from everything to reset
      Array.from(heatMapTriggers).forEach(trigger => {
        if (trigger.nodeName !== 'LI') {
          trigger.classList.remove('active');
          trigger.children[0].classList.remove('active');
          trigger.children[1].classList.remove('active');
        }
      });
    };

    /**
     * Utility function for changing the content
     * @param {object} e
     */
    const handleContentChange = linkTarg => {
      const targetContent = linkTarg.getAttribute('data-target');
      const newContent = modalContents[targetContent - 1]; // -1 because index starts at 0, not 1
      modalTitle.innerHTML = newContent.title;
      modalCopy.innerHTML = newContent.copy;
      modalLink.setAttribute('data-video', newContent.video_id);
      modalImg.src = `/assets/vms/dist/images/configurations/features/${newContent.img_url}`;
      // Fire analytics
      const modalCategory = 'Design - VMS';
      const modalAction = 'click';
      let modalLabel = `Feature - ${newContent.title}`;
      if (modalCategory, modalAction, modalLabel) {
        modalLabel = modalLabel.replace('<span>1</span>', '');
        modalLabel = modalLabel.replace('<span>2</span>', '');
        modalLabel = modalLabel.replace('<span>3</span>', '');
        modalLabel = modalLabel.replace('<span>4</span>', '');
        setTimeout(() => {
          ga('send', 'event', modalCategory, modalAction, modalLabel);
        }, 200);
      }
    };

    /**
     * Utility function for getting the modals current content index
     */
    const getModalIndex = () => Number(heatMapModal.getAttribute('data-step'));

    /**
     * Function for handling the modal closing
     */
    const handleModalClose = () => {
      resetTriggers();
      modalNavContainer.classList.remove('active');
      modalCoverUp.classList.remove('active');
      heatMapSection.classList.remove('active');
      heatMapModal.classList.remove('active');
      modalContainer.classList.remove('active');
      docBody.classList.remove('noscroll');
    };

    /**
     * Function for handling the modal opening
     * @param {object} link
     */
    const handleModalOpen = link => {
      // If the modal is already open and you click the same button, close it
      if (heatMapModal.classList.contains('active') && link.classList.contains('active')) {
        handleModalClose();
        return;
      }

      if (!heatMapModal.classList.contains('active')) {
        scrollTop(heatMapSection, getHeaderHeight());
      }

      resetTriggers();

      /**
       * check to see if the link has 1 or 2 children,
       * this determines if it was an icon or text trigger
       */
      let linkText = '';
      let linkClose = '';
      const isIconTrigger = link.children.length > 1;

      // If the trigger was an icon trigger, change it to an 'X'
      if (isIconTrigger) {
        // Get text el and close el and add active class
        linkText = link.querySelector('.text');
        linkClose = link.querySelector('.close');
      } else {
        const targetTrigger = link.getAttribute('data-target');
        const triggerLink = document.querySelector(`a[data-target="${targetTrigger}"]`);
        linkText = triggerLink.querySelector('.text');
        linkClose = triggerLink.querySelector('.close');

        triggerLink.classList.add('active');
      }

      // Update modals data-step for arrow navigation
      heatMapModal.setAttribute('data-step', link.getAttribute('data-target'));

      linkText.classList.add('active');
      linkClose.classList.add('active');

      // Add classes as needed
      link.classList.add('active');
      modalNavContainer.classList.add('active');
      modalCoverUp.classList.add('active');
      heatMapSection.classList.add('active');
      heatMapModal.classList.add('active');
      modalContainer.classList.add('active');

      docBody.classList.add('noscroll');
    };

    const handleArrowShift = arrow => {
      const shiftDirection = arrow.classList.contains('icon-next') ? 1 : -1;
      let newContentIndex = Number(getModalIndex() + shiftDirection);

      if (newContentIndex > CONTENT_LENGTH) {
        newContentIndex = 1;
      } else if (newContentIndex < 1) {
        newContentIndex = CONTENT_LENGTH;
      }

      const targetLink = heatMapSection.querySelector(`a[data-target="${newContentIndex}"]`);

      handleModalOpen(targetLink);
      handleContentChange(targetLink);
    };

    /**
     * Event Listeners
     */
    Array.from(heatMapTriggers).forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const linkTarg = e.currentTarget;
        handleModalOpen(linkTarg);
        handleContentChange(linkTarg);
      });
    });

    modalClose.addEventListener('click', handleModalClose);

    Array.from(modalArrows).forEach(arrow => {
      arrow.addEventListener('click', e => {
        const targetArrow = e.currentTarget;
        handleArrowShift(targetArrow);
      });
    });

    /**
     ******** TODO: Figure out touchmove fix for mobile devices to not scroll ********
     * Refer to whyskylights repo components/main,js
     */
    // docBody.addEventListener('touchmove', function(e) {
    //   console.log(e);
    //   console.log(docBody);
    // });
  }
}